import React from 'react';
import Login from '../../components/Login/Login';

const BuyerLogin = () => {
  return <Login role="buyer" />;
};

export default BuyerLogin;
